/**
 * SMS du livreur — menu Livraisons Clients.
 *
 * Les textes vivaient d'abord dans Paramètres › E-commerce ; ils ont rejoint le
 * menu des livraisons, là où on les cherche (demande de Philippe, 15/10/2026).
 *
 * N'envoie QUE `ecommerce.livreurSms` : `PATCH /tenants/:id/config` fusionne
 * `ecommerce` clé par clé, le reste des réglages de la boutique n'est pas touché.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import { api } from '../services/api';
import SmsLivreurSettings, { smsDepuisReglages, smsPourReglages } from '../components/settings/SmsLivreurSettings';

export default function SmsLivreurPage() {
  const { tenant, reloadTenant } = useTenant();
  const lus = () => smsDepuisReglages((tenant?.config?.ecommerce as any)?.livreurSms);
  const [sms, setSms] = useState(lus);
  const [etat, setEtat] = useState<'repos' | 'envoi' | 'ok' | 'erreur'>('repos');
  const [erreur, setErreur] = useState('');

  // La configuration du magasin arrive parfois après le premier rendu.
  useEffect(() => {
    setSms(lus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant?.id, (tenant?.config?.ecommerce as any)?.livreurSms]);

  const enregistrer = async () => {
    if (!tenant?.id) return;
    setEtat('envoi');
    try {
      await api.updateTenantConfig(tenant.id, { ecommerce: { livreurSms: smsPourReglages(sms) } });
      await reloadTenant();
      setEtat('ok');
      setTimeout(() => setEtat('repos'), 3000);
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'Erreur inconnue');
      setEtat('erreur');
    }
  };

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">SMS du livreur</h1>
        <p className="mt-2 text-gray-600">
          Les messages que l'application livreur prépare pour prévenir le client. Les livreurs se gèrent dans{' '}
          <Link to="/team?tab=drivers" className="text-blue-700 underline">Équipe › Livreurs</Link>.
        </p>
      </div>

      <SmsLivreurSettings value={sms} onChange={setSms} />

      <div className="flex items-center gap-4">
        <button
          onClick={enregistrer}
          disabled={etat === 'envoi'}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium disabled:opacity-50"
        >
          {etat === 'envoi' ? 'Enregistrement…' : 'Enregistrer les SMS'}
        </button>
        {etat === 'ok' && <span className="text-green-700 font-medium">Enregistré. Le livreur les verra au prochain chargement de sa tournée.</span>}
        {etat === 'erreur' && <span className="text-red-700">Non enregistré : {erreur}</span>}
      </div>
    </div>
  );
}
